"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoweredByStreemFooter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const PoweredByStreemFooter = () => {
    return ((0, jsx_runtime_1.jsx)(ui_react_1.Flex, Object.assign({ flex: "1 1 auto", mt: 3, "data-testid": "footer-branding" }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Column, Object.assign({ mb: 4, justifyContent: "flex-end", style: { minHeight: '50px' } }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { name: "PoweredByStreem" }) })) })));
};
exports.PoweredByStreemFooter = PoweredByStreemFooter;
//# sourceMappingURL=powered_by_streem_footer.js.map